import React, { useState } from 'react';
import './SummaryCards.css';

const fmt = v => v.toLocaleString('pt-BR', { style:'currency', currency:'BRL' });

export default function SummaryCards({ totalCartao, totalFixo, totalOutro, totalGeral, meta, diferenca, mes, onMetaChange, hideValues = false }) {
  const mask = v => hideValues ? '••••••' : fmt(v);
  const [editMeta, setEditMeta] = useState(false);
  const [metaVal, setMetaVal] = useState('');

  function startEditMeta() {
    setMetaVal(meta > 0 ? meta.toString() : '');
    setEditMeta(true);
  }

  function saveMeta() {
    onMetaChange(mes, metaVal);
    setEditMeta(false);
  }

  const isPositive = diferenca >= 0;

  return (
    <div className="summary-cards">
      <div className="sumcard">
        <div className="sumcard-label">💳 Gastos com Cartão</div>
        <div className="sumcard-value font-mono">{mask(totalCartao)}</div>
      </div>
      <div className="sumcard">
        <div className="sumcard-label">📌 Gastos Fixos</div>
        <div className="sumcard-value font-mono">{mask(totalFixo)}</div>
      </div>
      {totalOutro > 0 && (
        <div className="sumcard">
          <div className="sumcard-label">🗂 Outros</div>
          <div className="sumcard-value font-mono">{mask(totalOutro)}</div>
        </div>
      )}
      <div className="sumcard sumcard-total">
        <div className="sumcard-label">Σ Total do Mês</div>
        <div className="sumcard-value font-mono">{mask(totalGeral)}</div>
      </div>
      <div className="sumcard sumcard-meta">
        <div className="sumcard-label-row">
          <span className="sumcard-label">🎯 Limite Mensal</span>
          <button className="edit-meta-btn" onClick={editMeta ? saveMeta : startEditMeta}>
            {editMeta ? '✓' : '✎'}
          </button>
        </div>
        {editMeta ? (
          <input
            type="number"
            step="0.01"
            value={metaVal}
            onChange={e => setMetaVal(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && saveMeta()}
            autoFocus
            className="meta-input"
            placeholder="0,00"
          />
        ) : (
          <div className="sumcard-value font-mono">{mask(meta)}</div>
        )}
      </div>
      <div className={`sumcard sumcard-dif ${isPositive ? 'positive' : 'negative'}`}>
        <div className="sumcard-label">⇅ Diferença</div>
        <div className="sumcard-value font-mono">
          {hideValues ? '••••••' : `${isPositive ? '+' : ''}${fmt(diferenca)}`}
        </div>
        <div className="sumcard-hint">{isPositive ? 'Dentro do limite mensal ✓' : 'Limite mensal ultrapassado ✗'}</div>
      </div>
    </div>
  );
}
